define('plugin/invoice/step/InvoiceStep',['require','lib/controller/booking/BaseStep','lib/view/BookingUrlBuilder','Config'],function (require) {

    var BaseStep = require('lib/controller/booking/BaseStep');
    var BookingUrlBuilder = require('lib/view/BookingUrlBuilder');
    var Config = require('Config');

    return BaseStep.extend({

        _step: 'invoice',
        _requestModel: null,

        initialize: function () {
            BaseStep.prototype.initialize.apply(this);

            this._requestModel = this.getOption('requestModel');
        },

        hasView: function () {
            return false;
        },

        processStep: function () {
            var invoice = this._requestModel.get('invoice');

            var url = 'invoice/pay/' + invoice.get('id');
            if (invoice.get('status') === 'paid') {
                params = {
                    ids: invoice.getBookingIds(),
                    status: 'success'
                };
                if (Config.getInstance().getPluginStatus('approve_booking') && !invoice.get('payment_received')) {
                    params.status = 'pending';
                }

                url = BookingUrlBuilder.getInstance().buildUrl('finish_step', params);
            }

            Backbone.history.navigate(url, {trigger: true});
        },

        isValid: function () {
            var invoice = this._requestModel.get('invoice');
            return !(invoice && invoice.get('id'));

        },

        setBookingRequestModel: function (requestModel) {
            this._requestModel = requestModel;
        }

    });

});
